module.exports = __webpack_public_path__ + "img/tju-computer.0428e45d.png";